<template>
    <MessageScreen
        v-if="currentStep === steps.MESSAGE_SCREEN"
        :srcImageMessage="DocumentUploadIcon"
        :titleMessage="'Vamos prosseguir com o seu cadastro!'"
        :message="'Tenha em mãos sua CNH, RENAVAM e CRLV.'"
    />
    <FooterButton v-if="currentStep === steps.MESSAGE_SCREEN" :confirmData="confirmCurrentStep"/>
    <FormKit
        v-if="currentStep === steps.DOCUMENTATION_FROM"
        type="form"
        :value="{
            cnh_category:'',
            cnh_numero_espelho: '',
            cnh_registration_number:'',
            cnh_issue_city:'',
            cnh_issue_city_ibge_code:'',
            cnh_issuer_state:'',
            cnh_first_license_date: '',
            cnh_renach: ''
        }"
        submit-label="Continuar"
        @submit="confirmData"
    >
        <h2 class="text-xl font-bold mb-1">Insira os dados</h2>
        <FormKit
            type="select"
            name="cnh_category"
            label="Selecione a categoria da sua CNH*"
            placeholder="Selecione uma opção"
            validation="required"
            :validation-messages="{
                required: 'A categoria da sua CNH é obrigatória'
            }"
            :options="[
                { label: '', value: '' },
                { label: 'A', value: 'A' },
                { label: 'B', value: 'B' },
                { label: 'C', value: 'C' },
                { label: 'D', value: 'D' },
                { label: 'E', value: 'E' },
            ]"
        />
        <FormKit
            type="text"
            name="cnh_numero_espelho"
            id="cnh_numero_espelho"
            label="Número do CNH*"
            maxlength="20"
            validation="required"
            :validation-messages="{
                required: 'O número da sua CNH é obrigatório'
            }"
        />
        <FormKit
            type="text"
            name="cnh_registration_number"
            label="Número do registro*"
            maxlength="11"
            validation="required"
            :validation-messages="{
                required: 'O número de registro é obrigatório'
            }"
        />
        <FormKit
            type="text"
            id="cnh_issue_city"
            name="cnh_issue_city"
            v-model="cnh_issue_city"
            label="Cidade de emissão*"
            validation="required"
            :validation-messages="{
                required: 'A cidade de emissão é obrigatória'
            }"
        />
        <FormKit
          type="hidden"
          id="cnh_issue_city_ibge_code"
          name="cnh_issue_city_ibge_code"
          v-model="cnh_issue_city_ibge_code"
        />
        <FormKit
          type="hidden"
          id="cnh_issuer_state"
          name="cnh_issuer_state"
          v-model="cnh_issuer_state"
        />
        <FormKit
            name="cnh_first_license_date"
            type="date"
            label="Data da primeira habilitação*"
            validation="required"
            :validation-messages="{
                required: 'A data da sua primeira habilitação é obrigatória'
            }"
        />
        <FormKit
            type="text"
            name="cnh_renach"
            label="Número da renach*"
            maxlength="20"
            validation="required"
            :validation-messages="{
                required: 'O número da renach é obrigatório'
            }"
        />
        <template #submit>
            <FooterButton/>
        </template>
    </FormKit>
</template>
<script>
  import MessageScreen from '../../components/MessageScreen.vue'
  import FooterButton from '../../components/FooterButton.vue'
  import { useStore } from '../../../stores/cadastro.js'
  import DocumentUploadIcon from '../../../../public/images/Bonequinho-message.svg'
  import { ref } from 'vue'
  import { useRouter } from 'vue-router'
  import TomSelect from 'tom-select';

  export default {
      components: {
          MessageScreen,
          FooterButton,
      },
      data(){
          return{
            cnh_category: '',
            cnh_numero_espelho: '',
            cnh_registration_number: '',
            cnh_issue_city: '',
            cnh_issue_city_ibge_code: '',
            cnh_issuer_state: '',
            cnh_first_license_date: '',
            cnh_renach: ''
          }
      },
      setup() {
        const router = useRouter();
        const store = useStore();
        const currentStep = ref(1)
        const steps = {
            MESSAGE_SCREEN: 1,
            DOCUMENTATION_FROM: 2,
        }

        function confirmCurrentStep(){
            if(currentStep.value <= Object.keys(steps).length){
                currentStep.value++
            }
        }

        const confirmData = async (formData) => {
            await store.updateDocumentationsData(formData);
            router.push({ name: 'UploadCnh' })
        }

        return {
            confirmCurrentStep,
            confirmData,
            steps,
            currentStep,
            DocumentUploadIcon
        };
      },

    mounted() {
      this.setupTomSelect();
    },

    watch: {
      currentStep(newValue) {
        this.$nextTick(() => this.setupTomSelect());
      },
    },

    methods: {
      setupTomSelect() {
        const el = document.querySelector('#cnh_issue_city');
        if (el == null) {
          return;
        }

        new TomSelect(el, {
          maxItems: 1, // single-select
          valueField: 'name',
          labelField: 'name',
          placeholder: 'Cidade de emissão da CNH',
          searchField: ['name'],
          load: (query, callback) => {
            if (!query.length) return callback();
            fetch(`/_api_proxy/address/cities?search=${encodeURIComponent(query)}`)
              .then(response => response.json())
              .then(json => callback(json.items))
              .catch(() => callback());
          },
          render: {
            option: (item, escape) => {
              return `
              <div class="py-2 d-flex">
                <div class="mb-1">
                  <span class="h5">${escape(item.name)} - ${escape(item.state)}</span>
                </div>
              </div>`;
            },
            item: (data, escape) => {
              return `
              <span
                data-ibge-code="${escape(data.ibge_code)}"
                data-name="${escape(data.name)}"
                data-state="${escape(data.state)}"
              >${escape(data.name)} - ${escape(data.state)}</span>`;
            },
          },
          onChange: (value) => {
            let item;
            if (value == null || value === '' || (item = el.tomselect.getItem(value)) == null) {
              this.cnh_issue_city_ibge_code = null;
              this.cnh_issuer_state = null;
              return;
            }

            const { ibgeCode, state } = item.dataset;
            this.cnh_issue_city_ibge_code = ibgeCode;
            this.cnh_issuer_state = state;
          },
        });
      },
    },

  }
</script>
